// extracted by mini-css-extract-plugin
module.exports = {"fold":"fold1_fold__xg1h_","left":"fold1_left__qGNry","subheadline":"fold1_subheadline__yM0fh","right":"fold1_right__CnfvL"};